import { useState, useEffect } from 'react';

export function TrackingData() {
    const [trackingData, setTrackingData] = useState({
        utm_source: '',
        utm_medium: '',
        utm_campaign: '',
        utm_content: '',
        utm_term: '',
        gclid: ''
    });

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const params = new URLSearchParams(window.location.search);
            const newTrackingData = {
                utm_source: params.get('utm_source') || localStorage.getItem('utm_source') || '',
                utm_medium: params.get('utm_medium') || localStorage.getItem('utm_medium') || '',
                utm_campaign: params.get('utm_campaign') || localStorage.getItem('utm_campaign') || '',
                utm_content: params.get('utm_content') || localStorage.getItem('utm_content') || '',
                utm_term: params.get('utm_term') || localStorage.getItem('utm_term') || '',
                gclid: params.get('gclid') || localStorage.getItem('gclid') || ''
            };

            setTrackingData(newTrackingData);

            for (const key in newTrackingData) {
                if (newTrackingData[key]) {
                    localStorage.setItem(`utm_${key}`, newTrackingData[key]);
                }
            }
        }
    }, []);

    return trackingData;
}
